var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        class: _vm.$style.bg
    }, [
        _c('div', {
            class: _vm.$style.content
        }, [
            _c('div', {
                class: _vm.$style.topLogo
            }, [
                _c('img', {
                    attrs: {
                        "src": require("@/assets/img/landingPage/logo.png"),
                        "alt": ""
                    }
                })
            ]),
            _c('div', {
                class: _vm.$style.container
            }, [
                _c('h3', [
                    _vm._v("Seguridad Fiable")
                ]),
                _c('h5', [
                    _vm._v("Tecnología Avanzada")
                ]),
                _c('div', {
                    class: _vm.$style.header
                }, [
                    _c('p', {
                        class: _vm.$style.title
                    }, [
                        _vm._v("Monto-Máximo")
                    ]),
                    _c('div', {
                        class: _vm.$style.moneyBox
                    }, [
                        _c('img', {
                            attrs: {
                                "src": require("@/assets/img/landingPage/money-left.png"),
                                "alt": ""
                            }
                        }),
                        _c('h3', {
                            class: _vm.$style.moneyText
                        }, [
                            _vm._v("$30,000")
                        ]),
                        _c('img', {
                            attrs: {
                                "src": require("@/assets/img/landingPage/money-right.png"),
                                "alt": ""
                            }
                        })
                    ]),
                    _c('p', {
                        class: _vm.$style.rateBox
                    }, [
                        _vm._v(" Tasa diaria minima "),
                        _c('span', [
                            _vm._v("0.06%")
                        ])
                    ]),
                    _c('van-button', {
                        class: _vm.$style.creditBtn,
                        on: {
                            "click": _setup.clickBtn
                        }
                    }, [
                        _vm._v("Solicitar")
                    ])
                ], 1),
                _c('div', {
                    class: _vm.$style.chooseBox
                }, [
                    _c('h5', [
                        _vm._v("¿Por qué elegir Órale?")
                    ]),
                    _vm._m(0)
                ]),
                _c('div', {
                    class: _vm.$style.stepBox
                }, [
                    _c('h5', [
                        _vm._v("Proceso de préstamo")
                    ]),
                    _c('div', {
                        class: _vm.$style.stepList
                    }, [
                        _c('img', {
                            attrs: {
                                "src": require("@/assets/img/landingPage/step_img.png"),
                                "alt": ""
                            }
                        }),
                        _vm._m(1)
                    ])
                ]),
                _c('div', {
                    class: _vm.$style.bgBottom
                }, [
                    _c('div', {
                        class: _vm.$style.bgBottomContent
                    }, [
                        _c('img', {
                            attrs: {
                                "src": require("@/assets/img/landingPage/logo.png"),
                                "alt": ""
                            }
                        }),
                        _c('div', {
                            class: _vm.$style.bgBottomContentText
                        }, [
                            _c('img', {
                                attrs: {
                                    "src": require("@/assets/img/landingPage/email.png"),
                                    "alt": ""
                                }
                            }),
                            _c('p', [
                                _vm._v("orale-servicio@oralemx.com")
                            ])
                        ]),
                        _c('div', {
                            class: _vm.$style.bgBottomContentText
                        }, [
                            _c('img', {
                                attrs: {
                                    "src": require("@/assets/img/landingPage/phone.png"),
                                    "alt": ""
                                }
                            }),
                            _c('p', [
                                _vm._v("3341690252")
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]);
};
var staticRenderFns = [
    function() {
        var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
        return _c('ul', [
            _c('li', [
                _c('img', {
                    attrs: {
                        "src": require("@/assets/img/landingPage/product1.png"),
                        "alt": ""
                    }
                }),
                _c('span', [
                    _vm._v("Proceso sencillo")
                ])
            ]),
            _c('li', [
                _c('img', {
                    attrs: {
                        "src": require("@/assets/img/landingPage/product2.png"),
                        "alt": ""
                    }
                }),
                _c('span', [
                    _vm._v("Aprobación rápida")
                ])
            ]),
            _c('li', [
                _c('img', {
                    attrs: {
                        "src": require("@/assets/img/landingPage/product3.png"),
                        "alt": ""
                    }
                }),
                _c('span', [
                    _vm._v("Protegiendo la privacidad")
                ])
            ])
        ]);
    },
    function() {
        var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
        return _c('ul', [
            _c('li', [
                _vm._v("Descarga la app")
            ]),
            _c('li', [
                _vm._v("Complete la información")
            ]),
            _c('li', [
                _vm._v("Verificar la identidad")
            ]),
            _c('li', [
                _vm._v("Depósito exitoso")
            ])
        ]);
    }
];
export { render, staticRenderFns };
